<template>
  <div :class="$style.modal">
    <div :class="$style.modalContent">
      <ModalHeader
        :handleClose="handleClose"
        headerText="API Key"
        :showClose="true"
      />
      <div :class="$style.modalBody">
        <div :class="$style.apiKeyContainer">
          <TextLink
            :class="$style.apiKey"
            :onCopySuccess="handleCopySuccess"
          >
            {{ user.apiKey }}
          </TextLink>
        </div>
        <FlatActionButton
          :action="generateNewApiKey"
          :loading="loading"
          text="Generate New API Key"
        />
        <p :class="$style.bodyText">
          Generating a new API key will revoke access to the current API key.
          This will render all calls using the previous API key inaccessible.
        </p>
      </div>
      <ModalFooter
        :handleClose="handleClose"
        :handleMainAction="handleClose"
        mainActionText="close"
      />
    </div>
  </div>
</template>

<script>
import * as Constants from 'client/util/Constants';
import { get } from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import { notify } from 'client/util';
import FlatActionButton from 'components/Buttons/FlatActionButton.vue';
import ModalEventBus from 'components/Modal/ModalEventBus';
import ModalFooter from 'components/Modal/ModalComponents/ModalFooter.vue';
import ModalHeader from 'components/Modal/ModalComponents/ModalHeader.vue';
import TextLink from 'components/TextLink/TextLink.vue';
import UserApi from 'client/api/v2/UserApi';

const { error, info } = Constants.default;

export default {
  name: 'ApiSettingsModal',

  components: {
    FlatActionButton,
    ModalFooter,
    ModalHeader,
    TextLink,
  },

  data: () => ({
    loading: false,
  }),

  computed: {
    ...mapGetters('SettingsModule', { user: 'getUser' }),
  },

  methods: {
    ...mapActions('SettingsModule', ['updateUserSettings']),

    generateNewApiKey() {
      this.loading = true;
      UserApi.generateApiKey()
        .then((res) => {
          const apiKey = get(res, 'data.apiKey', undefined);
          if (!apiKey) {
            this.notifyError();
            return;
          }
          this.updateUserSettings({ apiKey });
        })
        .catch(() => {
          this.notifyError();
        })
        .finally(() => {
          this.loading = false;
        });
    },

    handleClose() {
      ModalEventBus.close();
    },

    handleCopySuccess() {
      notify(info, 'Copied to clipboard.');
    },

    notifyError() {
      notify(error, 'Unable to generate new API key');
    },
  },
};
</script>

<style scoped module>
@import "../Modal/css/ModalStyles.css";

@value (greyLight1, greyLight3) from '~css/colors.css';

.modal { text-align: center; }
.apiKeyContainer { user-select: text; }

.apiKey {
  cursor: pointer;
  display: inline-block;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 20px;
  padding: 0 4px;
}

.apiKey:hover {
  background-color: greyLight3;
  text-decoration: none;
}

.bodyText {
  margin-top: 20px;
  text-align: left;
}
</style>
